module.exports = __webpack_public_path__ + "static/media/TY for dummies.02640373.jpeg";